import { render, staticRenderFns } from "./MdhealtGrid.vue?vue&type=template&id=773c1fde"
import script from "./MdhealtGrid.vue?vue&type=script&lang=js"
export * from "./MdhealtGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports